export default __webpack_public_path__ + "static/media/Bandit's Chestguard of the Grasslands.242fb11d.jpg";